import { render } from "./BaseDialog.vue?vue&type=template&id=3c895b74&scoped=true"
import script from "./BaseDialog.vue?vue&type=script&lang=js"
export * from "./BaseDialog.vue?vue&type=script&lang=js"

import "./BaseDialog.vue?vue&type=style&index=0&id=3c895b74&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3c895b74"

export default script